import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from 'axios';
import '@/permission';
import VueClipboard from 'vue-clipboard2';
import i18n from '@/i18n';
import CtLangText from '@/components/ct-lang-text';
import {
    F_STOCK_TYPE_COIN,
    THOUSANDTHS,
    FORMAT_TIME
} from '@/utils/filter/index.js';

import { isMobileDevice } from '@/utils/tools-func';
Vue.prototype.$isMobileDevice = isMobileDevice();

import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/element-variables.scss';
import 'element-ui/lib/theme-chalk/icon.css';
import '@/styles/index.scss'; // global css
Vue.use(ElementUI);
Vue.component('CtLangText', CtLangText);
// 全局dom文本过滤器
Vue.filter('F_STOCK_TYPE_COIN', F_STOCK_TYPE_COIN);
Vue.filter('THOUSANDTHS', THOUSANDTHS);
Vue.filter('FORMAT_TIME', FORMAT_TIME);
// 导出组件
import JsonExcel from 'vue-json-excel';
Vue.component('DownloadExcel', JsonExcel);

import global_ from './utils/global'; // 引用文件
Vue.prototype.GLOBAL = global_; // 挂载到Vue实例上面

// 挂在websocket
import ws from '@/utils/socket/index';
Vue.prototype.$ws = ws;

// 事件总线
import { EventEmitter } from 'events';
Vue.prototype.$bus = new EventEmitter();

// 自定义指令
import Directive from '@/utils/directives/directives';
Vue.use(Directive);

// math.js
import { create, all } from 'mathjs';
const config = {
    epsilon: 1e-12,
    matrix: 'Matrix',
    number: 'BigNumber', // 可选值：number BigNumber ， BigNumber可以解决js小数点精度问题，而number不可行
    precision: 64,
    predictable: false,
    randomSeed: null
};
const math = create(all, config);
Vue.prototype.$math = math;

// Decimal.js
import Decimal from 'decimal.js';
Decimal.set({
    precision: 20,
    rounding: Decimal.ROUND_UP
});
Vue.prototype.$decimal = Decimal;

Vue.use(VueClipboard);
Vue.config.productionTip = false;

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app');

console.log('111: ', 111);
// 版本检测更新
let version = '';
const service = axios.create({
    baseURL: '',
    timeout: 150000 // request timeout
});
setInterval(() => {
    service({
        url: `${location.origin}?t=${+new Date()}`,
        method: 'get'
    }).then(res => {
        try {
            const { data } = res;
            const newVersion =
                data.match(/version=([^"]*)/) &&
                data.match(/version=([^"]*)/)[1]
                    ? data.match(/version=([^"]*)/)[1]
                    : '';
            if (version && newVersion && version !== newVersion) {
                // console.log('有内容更新');
                location.reload();
            }
            version = newVersion;
        } catch (err) {
            console.log(err);
        }
    });
}, 10000);
